export default __webpack_public_path__ + "static/media/fsk-05-a.2b46e086.jpg";